/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type Case4CauseToastQueryVariables = {};
export type Case4CauseToastQueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly user: ({
            readonly id: string;
            readonly permissions: ({
                readonly id: string;
                readonly oneCommerce: ({
                    readonly id: string;
                    readonly ceo: ({
                        readonly access: boolean | null;
                    }) | null;
                    readonly preferredCustomer: ({
                        readonly access: boolean | null;
                    }) | null;
                }) | null;
            }) | null;
            readonly cart: ({
                readonly id: string;
                readonly viaQualifiedCartTotal: number | null;
                readonly subTotalPriceOfItems: number | null;
                readonly promoCodeSavings: number | null;
                readonly pcPotentialSavings: ReadonlyArray<number | null> | null;
                readonly enrollingAsPc: boolean | null;
            }) | null;
            readonly conciergeUser: ({
                readonly id: string;
                readonly permissions: ({
                    readonly id: string;
                    readonly oneCommerce: ({
                        readonly id: string;
                        readonly ceo: ({
                            readonly access: boolean | null;
                        }) | null;
                        readonly preferredCustomer: ({
                            readonly access: boolean | null;
                        }) | null;
                    }) | null;
                }) | null;
                readonly cart: ({
                    readonly id: string;
                    readonly viaQualifiedCartTotal: number | null;
                    readonly subTotalPriceOfItems: number | null;
                    readonly promoCodeSavings: number | null;
                    readonly pcPotentialSavings: ReadonlyArray<number | null> | null;
                    readonly enrollingAsPc: boolean | null;
                }) | null;
            }) | null;
        }) | null;
    }) | null;
};
export type Case4CauseToastQuery = {
    readonly response: Case4CauseToastQueryResponse;
    readonly variables: Case4CauseToastQueryVariables;
};



/*
query Case4CauseToastQuery {
  viewer {
    id
    user {
      id
      permissions {
        id
        oneCommerce {
          id
          ceo {
            access
          }
          preferredCustomer {
            access
          }
        }
      }
      cart {
        id
        viaQualifiedCartTotal
        subTotalPriceOfItems
        promoCodeSavings
        pcPotentialSavings
        enrollingAsPc
      }
      conciergeUser {
        id
        permissions {
          id
          oneCommerce {
            id
            ceo {
              access
            }
            preferredCustomer {
              access
            }
          }
        }
        cart {
          id
          viaQualifiedCartTotal
          subTotalPriceOfItems
          promoCodeSavings
          pcPotentialSavings
          enrollingAsPc
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "permissions",
        "storageKey": null,
        "args": null,
        "concreteType": "PermissionsType",
        "plural": false,
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "oneCommerce",
                "storageKey": null,
                "args": null,
                "concreteType": "OneCommerceType",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "ceo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccessType",
                        "plural": false,
                        "selections": (v1 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preferredCustomer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccessType",
                        "plural": false,
                        "selections": (v1 /*: any*/)
                    }
                ]
            }
        ]
    } as any), v3 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "cart",
        "storageKey": null,
        "args": null,
        "concreteType": "Cart",
        "plural": false,
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "viaQualifiedCartTotal",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "subTotalPriceOfItems",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "promoCodeSavings",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "pcPotentialSavings",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "enrollingAsPc",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v4 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "viewer",
            "storageKey": null,
            "args": null,
            "concreteType": "Viewer",
            "plural": false,
            "selections": [
                (v0 /*: any*/),
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "conciergeUser",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                (v2 /*: any*/),
                                (v3 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "Case4CauseToastQuery",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": (v4 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "Case4CauseToastQuery",
            "argumentDefinitions": [],
            "selections": (v4 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "Case4CauseToastQuery",
            "id": null,
            "text": "query Case4CauseToastQuery {\n  viewer {\n    id\n    user {\n      id\n      permissions {\n        id\n        oneCommerce {\n          id\n          ceo {\n            access\n          }\n          preferredCustomer {\n            access\n          }\n        }\n      }\n      cart {\n        id\n        viaQualifiedCartTotal\n        subTotalPriceOfItems\n        promoCodeSavings\n        pcPotentialSavings\n        enrollingAsPc\n      }\n      conciergeUser {\n        id\n        permissions {\n          id\n          oneCommerce {\n            id\n            ceo {\n              access\n            }\n            preferredCustomer {\n              access\n            }\n          }\n        }\n        cart {\n          id\n          viaQualifiedCartTotal\n          subTotalPriceOfItems\n          promoCodeSavings\n          pcPotentialSavings\n          enrollingAsPc\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '89ed482a01a93342f516853bc4eee77d';
export default node;
